module.exports = __webpack_public_path__ + "img/18.bac4288d.gif";